<template>
  <h2>Duplicate Record Management</h2>

  <ModalBootstrap ModalId="deleteDuplicatePersonModal" ModalTitle="Delete Duplicate Person" ButtonText=""
    ref="deleteDuplicatePersonModal" aria-label="Delete Duplicate Person">

    <template v-slot:body>
      Are you sure you want to DELETE this Person? Doing so will remove all references to the person's Documents and Weapons. 
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.deleteDuplicatePersonModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="DeleteDuplicatePerson">Delete</button>

    </template>
  </ModalBootstrap>

  <ModalBootstrap ModalId="mergeDuplicatePersonModal" ModalTitle="Merge Duplicate Person" ButtonText=""
    ref="mergeDuplicatePersonModal" aria-label="Merge Duplicate Person">

    <template v-slot:body>
      <p>Select a Merge TARGET (Meaning: the person who you want to tranfer this person's Documents and Weapons TO)</p>
      <div>
        <table class="table">
          <thead>
            <tr>
              <th>Person ID</th>
              <th>Last Name</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Document Count</th>
              <th>Weapon Count</th>
              <th>Contract Id</th>
              <th>Selected</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="duplicateRecord in activeDuplicateList" @click="this.$refs['activeDuplicateRadio'+duplicateRecord.personId][0].click()" >
              <td>{{duplicateRecord.personId}}</td>
              <td>{{duplicateRecord.lastName}}</td>
              <td>{{duplicateRecord.firstName}}</td>
              <td>{{duplicateRecord.middleName}}</td>
              <td>{{duplicateRecord.documentCount}}</td>
              <td>{{duplicateRecord.weaponCount}}</td>
              <td>{{ duplicateRecord.contractId }}</td>
              <td>
                <input class="form-check-input" type="radio" v-model="this.activePerson.selectedDuplicateId" :value="duplicateRecord.personId" :ref="'activeDuplicateRadio'+duplicateRecord.personId" name="selectedItem" :checked="this.activePerson.selectedDuplicateId == duplicateRecord.personId">
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.mergeDuplicatePersonModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="MergeDuplicatePerson">Merge</button>

    </template>
  </ModalBootstrap>

  <DataTableComponent v-if="this.getDuplicatePeopleUrl" :data-url="this.getDuplicatePeopleUrl"
    :column-list-d-b="this.userContractColumnNames" :column-list-pretty="this.userContractColumnNamesPretty"
    column-name-id="contractUserProfileId" ref="duplicatePersonTable" :show-search="true"
    plural-data-name="Duplicate People" :center-column-indexes="[1, 3]" :order-column-index="1" :rows-per-page="50">

    <template #actionColumnEditSlot="actionColumnEditSlot">

      <td class="actionColumn tdclass">

        <div class="material-icons forIconEdit redIcon" data-tooltip="tooltip" title="Edit Record"
          @click="this.ShowDeleteModal(actionColumnEditSlot)"> delete </div>
          <div class="material-icons forIconEdit text-success" data-tooltip="tooltip" title="Edit Record"
          @click="this.ShowMergeModal(actionColumnEditSlot)" > merge </div>

      </td>

    </template>

  </DataTableComponent>
</template> 
  
<script>

import { store } from "@/store/store.js";
import $ from "jquery";
import DataTableComponent from "@/components/dataSupport/DataTable.vue";
import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue"

export default {
  name: "UserContractsTable",
  components: {
    DataTableComponent, ModalBootstrap
  },
  mounted() {
    this.getDuplicatePeopleUrl = store.webAPIUrl + "people/duplicaterecords";
    console.log(this.getDuplicatePeopleUrl)
  },
  data() {
    return {
      getDuplicatePeopleUrl: "",
      userContractColumnNames: ['personId', 'lastName', 'firstName', 'middleName', 'nin','bioGuid','documentCount', 'weaponCount', 'contractNumber', 'contractEndDate', 'contractId'],
      userContractColumnNamesPretty: ['personId', 'lastName', 'firstName', 'middleName', 'nin','bioGuid','documentCount', 'weaponCount', 'contractNumber', 'contractEndDate', 'contractId'],
      activePerson: {},
      activeDuplicateList:[],
    };
  },
  methods: {
    ShowDeleteModal(_personToDelete) {
      //console.log("Opening contract modal | data: ", _contractUser);
      this.activePerson = _personToDelete;
      this.$refs.deleteDuplicatePersonModal.ShowModal();
    },
    ShowMergeModal(_personToMerge) {
      //console.log("Opening contract modal | data: ", _contractUser);
      this.activePerson = _personToMerge;

      $.ajax({
                method: "POST",
                data: JSON.stringify(this.activePerson),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: store.webAPIUrl + "people/getduplicaterecords",
                success: (result) => {
                  console.log("getting duplicate list: ", result);
                  this.activeDuplicateList = result;
                  this.activePerson.selectedDuplicateId = result[0].personId;
                },
            });

      this.$refs.mergeDuplicatePersonModal.ShowModal();
    },
    EditModalClosed() {
      //console.log("edit modal closed");
      this.userContractEditing = {};
    },
    DeleteDuplicatePerson(){
      console.log("deleting person", this.activePerson);
      $.ajax({
          method: "DELETE",
          data: JSON.stringify(this.activePerson),
          contentType: "application/json; charset=utf-8",
          url: store.webAPIUrl + "people/deleteduplicaterecord/" + this.activePerson.personId,
          success: (result) => {
              result;
              this.$refs.deleteDuplicatePersonModal.HideModal();
              this.$refs.duplicatePersonTable.LoadDataAndInitializeTable(this.getDuplicatePeopleUrl);
              console.log(successMessage);
          },
      });
    },
    MergeDuplicatePerson(){
      console.log("merging person", this.activePerson);

      $.ajax({
          method: "PUT",
          data: JSON.stringify(this.activePerson),
          contentType: "application/json; charset=utf-8",
          url: store.webAPIUrl + "people/mergeDuplicateRecord/" + this.activePerson.selectedDuplicateId,
          success: (result) => {

              result;
              this.$refs.mergeDuplicatePersonModal.HideModal();
              this.$refs.duplicatePersonTable.LoadDataAndInitializeTable(this.getDuplicatePeopleUrl);
          },
      });
    },
  },
  unmounted() {

    //console.log("force update user contracts table"); 
    this.$forceUpdate();
  }
}
</script>
  
<style scoped>
.dtContainer {
  display: flex;
  flex-direction: column;
  margin: 15px;
  padding-right: 5px;
  padding-bottom: 15px;
  margin-bottom: 30px;
  width: 88%;
}

.forIconEdit {
  cursor: pointer;
  color: #0f63a8 !important;
}

p {
  text-align: left;
}

.activeCheckBoxContainer {
  padding-bottom: 1.25rem;
}

.radioContainer {
  margin-bottom: 1rem;
}

.excelButton {
  width: 175px;
}

#topContainer {
  display: flex;
}

#creatNewContractUserButtonAndLabel {
  width: 270px;
  display: flex;
  justify-content: space-between;
}

#radioContainerActiveButtons {
  width: 185px;
  display: flex;
  justify-content: space-evenly;
}
    .redIcon {
        color: #DC143C !important;
    }
th{
  font-size:12px;
}
</style>
